import { render } from "./Attendance.vue?vue&type=template&id=4b7dafde&scoped=true"
import script from "./Attendance.vue?vue&type=script&lang=js"
export * from "./Attendance.vue?vue&type=script&lang=js"

import "./Attendance.vue?vue&type=style&index=0&id=4b7dafde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7dafde"]])

export default __exports__